import { Banknote, TrendingUp } from 'lucide-react';

interface SalaryCardsProps {
  caption: string;
  intro?: string;
  rows: Array<string[]>;
}

export function SalaryCards({ caption, intro, rows }: SalaryCardsProps) {
  return (
    <div className="mb-12">
      <h3 className="mb-3 flex items-center gap-2 text-lg font-bold text-slate-900 md:text-xl">
        <span className="h-5 w-1 rounded-full bg-[#3bbdad]" />
        {caption}
      </h3>
      {intro && <p className="mb-4 text-slate-600">{intro}</p>}
      <div className="grid gap-4 sm:grid-cols-2">
        {rows.map((row, index) => (
          <div
            key={index}
            className="group relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition-transform hover:-translate-y-1"
          >
            <div className="absolute left-0 top-0 h-full w-1 bg-[#3bbdad]" />
            <div className="flex items-start justify-between gap-4">
              <div>
                <span
                  className="text-sm font-semibold uppercase tracking-wide text-slate-500"
                  dangerouslySetInnerHTML={{ __html: row[1] || '' }}
                />
                <div
                  className="mt-1 text-lg font-bold text-slate-900"
                  dangerouslySetInnerHTML={{ __html: row[0] || '' }}
                />
              </div>
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#f0fdfa] text-[#3bbdad]">
                <TrendingUp className="h-5 w-5" />
              </div>
            </div>
            <div className="mt-4 flex items-center justify-between border-t border-slate-100 pt-3">
              <span className="flex items-center gap-1.5 text-sm text-slate-500">
                <Banknote className="h-4 w-4" />
                Estimated range
              </span>
              <span
                className="text-base font-semibold text-[#0f766e]"
                dangerouslySetInnerHTML={{ __html: row[2] || '' }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
